module.exports = __webpack_public_path__ + "img/166.414cb84f.svg";